import { faAngleUp, faAsterisk, faBold, faCode, faHeading, faImage, faIndent, faItalic, faLink, faListOl, faListUl, faOutdent, faParagraph, faQuoteLeft, faRedo, faStrikethrough, faSubscript, faSuperscript, faTable, faUnderline, faUndo, } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
export var icons = {
    // em: <FontAwesomeIcon icon={faItalic} />,
    italic: React.createElement(FontAwesomeIcon, { icon: faItalic }),
    // strong: <FontAwesomeIcon icon={faBold} />,
    bold: React.createElement(FontAwesomeIcon, { icon: faBold }),
    code: React.createElement(FontAwesomeIcon, { icon: faCode }),
    subscript: React.createElement(FontAwesomeIcon, { icon: faSubscript }),
    superscript: React.createElement(FontAwesomeIcon, { icon: faSuperscript }),
    underline: React.createElement(FontAwesomeIcon, { icon: faUnderline }),
    strikethrough: React.createElement(FontAwesomeIcon, { icon: faStrikethrough }),
    link: React.createElement(FontAwesomeIcon, { icon: faLink }),
    paragraph: React.createElement(FontAwesomeIcon, { icon: faParagraph }),
    heading: React.createElement(FontAwesomeIcon, { icon: faHeading }),
    blockquote: React.createElement(FontAwesomeIcon, { icon: faQuoteLeft }),
    codeBlock: React.createElement(FontAwesomeIcon, { icon: faCode }),
    orderedList: React.createElement(FontAwesomeIcon, { icon: faListOl }),
    bulletList: React.createElement(FontAwesomeIcon, { icon: faListUl }),
    image: React.createElement(FontAwesomeIcon, { icon: faImage }),
    table: React.createElement(FontAwesomeIcon, { icon: faTable }),
    footnote: React.createElement(FontAwesomeIcon, { icon: faAsterisk }),
    undo: React.createElement(FontAwesomeIcon, { icon: faUndo }),
    redo: React.createElement(FontAwesomeIcon, { icon: faRedo }),
    indent: React.createElement(FontAwesomeIcon, { icon: faIndent }),
    outdent: React.createElement(FontAwesomeIcon, { icon: faOutdent }),
    joinUp: React.createElement(FontAwesomeIcon, { icon: faAngleUp }),
};
